import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  CustomerReturnSearchCriteria,
  PageListBean,
  RestCustomerReturnListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { CustomerReturnService } from "../services/CustomerReturnService.js";
export class CustomerReturnLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new CustomerReturnSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new CustomerReturnSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let customerLookupCriteria = new CustomerReturnSearchCriteria();
    customerLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = CustomerReturnLookupCriteraHandler(
      companyCode,
      customerLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      customerLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getCustomerReturnStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Date", "customerReturnDate", 0, false); //1
    this.addColumnDefinition("Customer", "customerCode", 0, false); //2
    this.addColumnDefinition("Name", "customerName", 0, false); //3
    this.addColumnDefinition("Invoice#", "invoiceNumber", 0, false); //3
    this.addColumnDefinition("Status", "customerReturnStatus", 0, false); //3
    this.addColumnDefinition("ReturnAmount", "totalReturnAmount", 1, false); //3
    this.addColumnDefinition("Currency", "customerCurrencyCode", 0, false); //3
    this.addColumnDefinition("Source", "createdSourceType", 0, false);
  }
  loadCustomerReturnList = (lookup_dialog, pageNumber, searchCriteria) => {
    let cust_criteria = new CustomerReturnSearchCriteria(); //To be fetched from CriteriaHandler
    cust_criteria.companyCode = this.companyCode;

    if (searchCriteria !== undefined && searchCriteria !== null) {
      cust_criteria.customerCode = searchCriteria.customerCode;
    }
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 50; //TODO --> Fetch from Config
    cust_pageList.currentPage = pageNumber;
    cust_pageList.pageNumber = pageNumber;
    let cust_requestInput = new RestCustomerReturnListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    CustomerReturnService.getCustomerReturnPageList(
      cust_requestInput,
      (response) =>
        this.loadCustomerReturnListResponse(response, lookup_dialog),
      this.loadCustomerReturnListError
    );
  };
  loadCustomerReturnListResponse = (response, lookup_dialog) => {
    let customerList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.customerReturnPageList != null &&
      response.data.customerReturnPageList.customerReturns !== null
    ) {
      customerList = response.data.customerReturnPageList.customerReturns;
      totalCount = response.data.customerReturnPageList.totalCount;
      currentPageNumber = response.data.customerReturnPageList.currentPage;
      pageSize = response.data.customerReturnPageList.pageSize;
      customerList.map((cl) => {
        cl.customerReturnStatus = ModuleUtils.getCustomerReturnStatusCaption(
          cl.customerReturnStatus
        );
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = customerList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadCustomerReturnListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.customerReturnNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.customerReturnNumberContains = filterText;
        this.searchCriteria = new CustomerReturnSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadCustomerReturnList(lookup_dialog, pageNumber, search);
    }
  }
}
const CustomerReturnLookupCriteraHandler = (
  companyCode,
  customerReturnLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new CustomerReturnSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new CustomerReturnSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  ref={this.focusRef}
                  id="customerCode"
                  name="customerCode"
                  onChange={this.onChange}
                  value={searchCriteria.customerCode}
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
